import React from 'react';

import InfoTab from '../Components/InfoTab/InfoTab';
import ConsentForm from '../Components/Consent/ConsentForm';
import DataForm from '../Components/DataForm/DataForm';
import PhotoForm from '../Components/PhotoForm/PhotoForm';
import SendData from '../Components/SendData/SendData';

// import CodeReader from '../Components/CodeReader/CodeReader';
import TestComponent from '../../../Components/TestComponent'
// import QRCodePage from '../components/CodeReader/QRCodePage';
import Tabs from '../../../Components/UI/Tabs/Tabs';
// import Counter from '../components/TestComponent/Counter';

const SubmitPage = (props) => {
  return <>
    <section style={{margin: '0 auto', width: '90%'}}>
      <Tabs titles = {['Info', 'Einver\u00ADständnis', 'Frage\u00ADbogen', 'Foto', 'Senden']}>
        <InfoTab />
        <ConsentForm consentId={props.railsData.consentId} />
        <DataForm formId={props.railsData.formId} />
        <PhotoForm />
        <SendData />
      </Tabs>
    </section>
  </>
};

const TSubmitPage = (props) => {
  return <>
    <section style={{margin: '4rem auto', width: '90%'}}>
      <TestComponent />
    </section>
  </>
};

export default SubmitPage;
